module.exports = __webpack_public_path__ + "img/technology-01.47137811.png";